const ScrollAnchor = ({ id } : { id: string} ) => {
    return <span id={id}></span>
}

export default ScrollAnchor;
